import { z } from "zod/v4";

import {
  PatchStripeSubscriptionLinkDtoSchema,
  StripeSubscriptionLinkDtoSchema,
} from "../../../dtos/stripe-subscription-links";

export const PatchSubscriptionLinkRequestBodySchema = z.object({
  organizationId: z.uuid(),
  subscriptionLink: PatchStripeSubscriptionLinkDtoSchema,
});

export const PatchSubscriptionLinkPathParamsSchema = z.object({
  subscriptionLinkId: z.uuid(),
});

export type PatchSubscriptionLinkPathParamsType = z.infer<
  typeof PatchSubscriptionLinkPathParamsSchema
>;

export const PatchSubscriptionLinkResponseBodySchema = z.object({
  subscriptionLink: StripeSubscriptionLinkDtoSchema,
});

export type PatchSubscriptionLinkRequestBodyType = z.infer<
  typeof PatchSubscriptionLinkRequestBodySchema
>;
export type PatchSubscriptionLinkResponseBodyType = z.infer<
  typeof PatchSubscriptionLinkResponseBodySchema
>;
